import { DebtEntity, DebtFilter } from '../../models'

export const SET_DEBTS = 'SET_DEBTS'
export const SET_TOTAL_DEBTS = 'SET_TOTAL_DEBTS'
export const SET_DEBTS_LOADED = 'SET_DEBTS_LOADED'
export const SET_DEBT_FILTER = 'SET_DEBT_FILTER'

export interface DebtState {
  debts: DebtEntity[]
  totalDebts: number
  isDebtsLoaded: boolean
  debtFilter: DebtFilter
}

interface SetDebtsAction {
  type: typeof SET_DEBTS
  payload: DebtEntity[]
}

interface SetTotalDebtsAction {
  type: typeof SET_TOTAL_DEBTS
  payload: number
}

interface SetDebtsLoadedAction {
  type: typeof SET_DEBTS_LOADED
  payload: boolean
}

interface SetDebtFilterAction {
  type: typeof SET_DEBT_FILTER
  payload: DebtFilter
}

export type DebtAction =
  | SetDebtsAction
  | SetDebtsLoadedAction
  | SetDebtFilterAction
  | SetTotalDebtsAction
